export default "__VITE_ASSET__eEeyBZ0f__"